import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useRouteMatch } from 'react-router-dom'

import { TableHelper } from '../../../../tables'
import { QuizTable } from '../../../../tables/quiz-table'

const Quizzes = observer(() => {
  const match = useRouteMatch<any>('/content/paths/:id/quizzes')
  const pathID = Number(match?.params?.id)

  const [tableHelper] = useState(new TableHelper('list_path_quizzes', 'quizzes', 'paths', pathID))

  return <QuizTable tableHelper={tableHelper} />
})

export const PathQuizzesTab = (props: any) => {
  const { id } = props
  return {
    name: 'Quizzes',
    path: `/content/paths/${id}/quizzes`,
    component: () => <Quizzes />,
  }
}
